import * as React from 'react';
import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { SimplePhone } from '../../components/SimplePhone';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { trackShowPhone } from '../BuilderBlockContainer/tracking';
import { BuilderChatButtonContainer } from '../BuilderChatButton';
import { INewbuildingSeller } from '../../types/newbuilding/seller';
import { getGALabel } from '../../selectors/newbuilding/getGALabel';
import { useApplicationContext } from '../../utils/applicationContext';

interface IContactsContainerProps {
  seller: INewbuildingSeller;
}

const CALL_BUTTON_STYLES = {
  size: 'M' as const,
  beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
};

export function ContactsContainer({ seller }: IContactsContainerProps) {
  const gaLabel = useSelector(getGALabel);
  const newbuildingId = useSelector(getNewbuildingId);

  const hasPhone = seller.phone && seller.phone.number;
  const hasChat = seller.chat?.isEnabled && seller.realtyUserId;

  const chatContacts = React.useMemo(() => {
    return {
      builders: [],
      sellers: [seller],
    };
  }, [seller]);

  const { httpApi, logger } = useApplicationContext();

  const pageType = EPageTypes.NewbuildingCard;
  const platformType = EPlatformTypes.WebDesktop;
  const placeType = 'Open_jk_card_author_block';

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone({
      gaLabel,
      newbuildingId,
      isBuilder: false,
    });
  }, [gaLabel, newbuildingId]);

  if (!hasPhone && !hasChat) {
    return null;
  }

  return (
    <>
      {hasPhone && (
        <SimpleCall
          builders={[]}
          sellers={[seller]}
          onShowPhoneClick={onShowPhoneClick}
          openContactsStyles={CALL_BUTTON_STYLES}
          showPhoneStyles={CALL_BUTTON_STYLES}
          SinglePhoneComponent={SimplePhone}
          httpApi={httpApi}
          logger={logger}
          pageType={pageType}
          platformType={platformType}
          placeType={placeType}
          singlePhoneButtonText="Показать телефон"
        />
      )}
      {hasChat && (
        <BuilderChatButtonContainer
          forcedContacts={chatContacts}
          placeType={placeType}
          buttonTheme="fill_white_primary"
        />
      )}
    </>
  );
}
